// Model used by generic_collection
// extend this model if specific functionality is required (i.e. validation)
define(function() {
	const GenericCollectionModel = require('civicsBase/generic_model');

	return GenericCollectionModel.extend({
		parse: function(response) {
			//console.log('service request model', response);
			return response;
		}
	});
});
